<div
  appDroppable
  [appDroppableDisabled]="busy() || dragBusy()"
  [appDroppablePredicate]="accepts"
  (appDroppableEnter)="dragOver.set(true)"
  (appDroppableLeave)="dragOver.set(false)"
  (appDroppableDrop)="drop($event)"
>
  @if (appearance() === 'rail') {
    <app-button2 appearance="primary" size="s" [height]="32" rounding="lg" class="w-full"
      stchPopover stchPopoverTrigger="click" stchPopoverPlacement="bottomLeft" [stchPopoverContent]="railMenu" [stchPopoverShowUntil]="menuChosen" [stchPopoverDismissGuard]="mayDismiss">
      <app-icon name="plus" size="m" /> New form <app-icon name="chevron-down" [size]="14" />
    </app-button2>
  } @else {
  <app-quick-action-button
    label="New form"
    hint="Drag to create"
    dropLabel="Drop to create"
    [dragOver]="dragOver()"
    ariaLabel="New form"
    stchPopover
    stchPopoverTrigger="click"
    stchPopoverPlacement="bottomLeft"
    [stchPopoverContent]="menu"
    [stchPopoverShowUntil]="menuChosen"
    [stchPopoverDismissGuard]="mayDismiss"
  />
  }
</div>
@if (busy() || dragBusy()) {
  <p role="status">Creating form…</p>
}
@if (notice()) {
  <p role="status">{{ notice() }}</p>
}
@if (canRetry()) {
  <app-button2 [disabled]="dragBusy()" (click)="retryDrag()">Retry</app-button2>
  @if (canKeep()) {
    <app-button2 appearance="secondary-text" [disabled]="dragBusy()" (click)="keepDrag()">Keep without link</app-button2>
  }
  <app-button2 appearance="secondary-text" [disabled]="dragBusy() || !canCancel()" (click)="cancelDrag()">Cancel remaining items</app-button2>
}
@if (error()) {
  <p role="alert" class="text-sm text-error">{{ error() }}</p>
}
@if (aiForm()) {
  <label class="flex flex-col gap-2 py-2"
    >What should the form cover?
    <textarea class="rounded border border-border p-2" [formControl]="prompt" rows="3" maxlength="4000"></textarea>
  </label>
  <app-button2 [disabled]="busy() || !prompt.value.trim()" (click)="blank(true)">Create with Stitchy</app-button2>
}
<ng-template #menu
  ><app-context-menu-window>
    <app-context-menu-item title="Blank form" [disabled]="busy()" (execute)="menuChosen.next(); blank()" />
    <app-context-menu-item title="From a template" [disabled]="busy()" (execute)="menuChosen.next(); choose('template')" />
    <app-context-menu-item title="Import form" [disabled]="busy()" (execute)="menuChosen.next(); choose('import')" />
    <app-context-menu-item
      title="Create with Stitchy"
      [disabled]="busy() || !stitchyCreate"
      [note]="stitchyCreate ? undefined : stitchyUnavailable"
      [trailingNote]="stitchyCreate ? undefined : 'Not connected'"
      (execute)="menuChosen.next(); aiForm.set(true)"
    />
  </app-context-menu-window
></ng-template>
<!-- The nav menu, each choice with its icon, as Sheets' New workbook menu and Slides' New deck menu
     (slides-rail-controls.component.html:31-38). -->
<ng-template #railMenu>
  <app-context-menu-window>
    <app-context-menu-item appearance="nav" title="Blank form" [disabled]="busy()" (execute)="menuChosen.next(); blank()" />
    <app-context-menu-item appearance="nav" title="From a template" icon="sapphire-template" [disabled]="busy()" (execute)="menuChosen.next(); choose('template')" />
    <app-context-menu-item appearance="nav" title="Import form" icon="upload" [disabled]="busy()" (execute)="menuChosen.next(); choose('import')" />
  </app-context-menu-window>
</ng-template>
